<template>

    <Page>

        <ImageAndText 
            src="/Challenge/uncertain-future.png"
            border
            image-class="rounded-xl"
            floor-shadow>

            <h2 class="mb-4">Revenue is under attack!</h2>
            <p class="font-normal text-white/80">
                We are experiencing soft market conditions,
                currently in decline and forecast to get worse.
            </p>

        </ImageAndText>

    </Page>

</template>